export const pattern15Data = [
  {
    id: 1,
    koreanChunks: ["누군가", "두었다 그들의 우산을", "회의실에"],
    englishChunks: ["Someone", "left their umbrella", "in the meeting room"],
    fullEnglish: "Someone left their umbrella in the meeting room.",
    explanation:
      "이 문장은 주어(Someone), 동사(left), 목적어(their umbrella)와 장소(in the meeting room)를 포함하는 기본 문장 구조입니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "만약 누군가가 가지고 있다면",
      "질문들을",
      "새로운 시스템에 대해",
      "연락하세요 IT 지원팀에 ",
    ],
    englishChunks: [
      "If anyone has",
      "questions",
      "about the new system",
      "please contact IT support",
    ],
    fullEnglish:
      "If anyone has questions about the new system, please contact IT support.",
    explanation:
      "이 문장은 조건절(If anyone has questions about the new system)과 주절(please contact IT support)로 구성된 복합문입니다. 조건과 그에 따른 행동을 나타냅니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "모든 사람은 요구됩니다",
      "완료하도록",
      "규정 준수 교육을",
      "금요일까지",
    ],
    englishChunks: [
      "Everyone is required",
      "to complete",
      "the compliance training",
      "by Friday",
    ],
    fullEnglish:
      "Everyone is required to complete the compliance training by Friday.",
    explanation:
      "이 문장은 주어(Everyone), 동사구(is required to complete), 목적어(the compliance training)와 시간 표현(by Friday)을 포함하는 문장 구조입니다. 의무나 요구사항을 나타내는 표현을 사용했습니다.",
  },
  {
    id: 4,
    koreanChunks: ["아무도 가능하지 않았다", "받을", "고객의 전화를"],
    englishChunks: ["No one was available", "to take", "the client's call"],
    fullEnglish: "No one was available to take the client's call.",
    explanation:
      "이 문장은 주어(No one), 동사구(was available to take), 목적어(the client's call)를 포함하는 문장 구조입니다. 가능성이나 이용 가능성을 나타내는 표현을 사용했습니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "누구나 그.. 관심있는",
      "참여하는데 워크숍에",
      "등록해야 합니다",
      "정오까지",
    ],
    englishChunks: [
      "Anybody interested",
      "in joining the workshop",
      "should register",
      "by noon",
    ],
    fullEnglish:
      "Anybody interested in joining the workshop should register by noon.",
    explanation:
      "이 문장은 주어(Anybody interested in joining the workshop), 동사구(should register), 시간 표현(by noon)을 포함하는 문장 구조입니다. 권고나 의무를 나타내는 'should'를 사용했습니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "아무도 알지 못했다",
      "비밀번호를",
      "접근하기 위한",
      "보안 폴더에",
    ],
    englishChunks: [
      "Nobody knew",
      "the password",
      "to access",
      "the secure folder",
    ],
    fullEnglish: "Nobody knew the password to access the secure folder.",
    explanation:
      "이 문장은 주어(Nobody), 동사(knew), 목적어(the password)와 목적의 부정사구(to access the secure folder)를 포함하는 문장 구조입니다. 부정 주어 'Nobody'를 사용하여 모든 사람이 비밀번호를 모르는 상태를 표현했습니다.",
  },
  {
    id: 7,
    koreanChunks: ["어느 제품도 충족하지 못했다", "품질 기준을"],
    englishChunks: ["Neither product met", "the quality standards"],
    fullEnglish: "Neither product met the quality standards.",
    explanation:
      "이 문장은 주어(Neither product), 동사(met), 목적어(the quality standards)를 포함하는 문장 구조입니다. 부정 주어 'Neither'를 사용하여 두 제품 모두 품질 기준을 충족하지 못했음을 표현했습니다.",
  },
  {
    id: 8,
    koreanChunks: ["어떤 후보자도 가지고 있지 않았다", "필요한 자격증을"],
    englishChunks: ["None of the candidates had", "the required certification"],
    fullEnglish: "None of the candidates had the required certification.",
    explanation:
      "이 문장은 주어(None of the candidates), 동사(had), 목적어(the required certification)를 포함하는 문장 구조입니다. 부정 주어 'None of'를 사용하여 모든 후보자가 필요한 자격증을 가지고 있지 않음을 표현했습니다.",
  },
  {
    id: 9,
    koreanChunks: ["일부 보고서들이 빠져있는 중이었다.", "중요한 정보를"],
    englishChunks: ["Some of the reports were missing", "key information"],
    fullEnglish: "Some of the reports were missing key information.",
    explanation:
      "이 문장은 주어(Some of the reports), 동사구(were missing), 목적어(key information)를 포함하는 문장 구조입니다. 'Some of'를 사용하여 전체 중 일부를 지칭하고, 과거진행형을 사용하여 정보가 누락된 상태였음을 표현했습니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "문제가 있다",
      "결제시스템에",
      "그... 필요한 즉각적인 주의가",
    ],
    englishChunks: [
      "There is a problem with the payment system",
      "that needs immediate attention",
    ],
    fullEnglish:
      "There is a problem with the payment system that needs immediate attention.",
    explanation:
      "이 문장은 'There is' 구문으로 시작하여 존재를 나타내고, 주어(a problem with the payment system)와 이를 수식하는 관계절(that needs immediate attention)을 포함하는 문장 구조입니다. 관계대명사 'that'을 사용하여 문제의 특성을 추가로 설명했습니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "여러 가지 새로운 정책들이 있다",
      "그...직원들이 검토해야 하는",
    ],
    englishChunks: [
      "There are several new policies",
      "that employees should review",
    ],
    fullEnglish: "There are several new policies that employees should review.",
    explanation:
      "이 문장은 'There are' 구문으로 시작하여 존재를 나타내고, 주어(several new policies)와 이를 수식하는 관계절(that employees should review)을 포함하는 문장 구조입니다. 관계대명사 'that'을 사용하여 정책에 대한 추가 정보를 제공했습니다.",
  },
  {
    id: 12,
    koreanChunks: ["여러 불만이 있었다", "새로운 인터페이스에 대한"],
    englishChunks: [
      "There were multiple complaints",
      "about the new interface",
    ],
    fullEnglish: "There were multiple complaints about the new interface.",
    explanation:
      "이 문장은 'There were' 구문으로 시작하여 과거의 존재를 나타내고, 주어(multiple complaints)와 이를 수식하는 전치사구(about the new interface)를 포함하는 문장 구조입니다. 'about'이라는 전치사를 사용하여 불만의 대상을 명확히 했습니다.",
  },
  {
    id: 13,
    koreanChunks: ["음료수가 있을것이다", "제공되는", "교육 세션 후에"],
    englishChunks: [
      "There will be refreshments",
      "provided",
      "after the training session",
    ],
    fullEnglish:
      "There will be refreshments provided after the training session.",
    explanation:
      "이 문장은 'There will be' 구문으로 시작하여 미래의 존재를 나타내고, 주어(refreshments)와 이를 수식하는 과거분사(provided)와 시간을 나타내는 전치사구(after the training session)를 포함하는 문장 구조입니다. 'after'라는 전치사를 사용하여 음료수가 제공될 시점을 명확히 했습니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "성과 평가가 있을 것이다",
      "모든 직원들을 위한 ",
      "다음 분기에",
    ],
    englishChunks: [
      "There will be a performance review",
      "for all employees",
      "next quarter",
    ],
    fullEnglish:
      "There will be a performance review for all employees next quarter.",
    explanation:
      "이 문장은 'There will be' 구문으로 시작하여 미래의 존재를 나타내고, 주어(a performance review for all employees)와 시간을 나타내는 명사구(next quarter)를 포함하는 문장 구조입니다. 'next quarter'라는 시간 표현을 사용하여 성과 평가가 이루어질 시점을 명확히 했습니다.",
  },
];
